module.exports = "/_next/static/images/d1f109171ab349d92049ff0cde4e21d3-image-left-xs.jpg.webp";